import type { GtmLeadStatusFilter, GtmPlayStatus } from "../api/GtmApi";

/** Central TanStack Query keys for GTM. */
export const gtmQueryKeys = {
  all: ["gtm"] as const,
  brain: (workspaceId: string) => [...gtmQueryKeys.all, "brain", workspaceId] as const,
  session: (workspaceId: string) => [...gtmQueryKeys.all, "session", workspaceId] as const,
  approveRisk: (workspaceId: string) =>
    [...gtmQueryKeys.all, "approveRisk", workspaceId] as const,
  plays: (workspaceId: string, status?: GtmPlayStatus | "all") =>
    [...gtmQueryKeys.all, "plays", workspaceId, status ?? "all"] as const,
  play: (workspaceId: string, playId: string) =>
    [...gtmQueryKeys.all, "play", workspaceId, playId] as const,
  leadSearch: (workspaceId: string, playId: string) =>
    [...gtmQueryKeys.all, "leadSearch", workspaceId, playId] as const,
  candidates: (workspaceId: string, playId: string, status?: "found" | "dismissed") =>
    [...gtmQueryKeys.all, "candidates", workspaceId, playId, status ?? "all"] as const,
  leads: (workspaceId: string, playId: string, status?: GtmLeadStatusFilter) =>
    [...gtmQueryKeys.all, "leads", workspaceId, playId, status ?? "all"] as const,
  sequenceTemplate: (workspaceId: string, playId: string) =>
    [...gtmQueryKeys.all, "sequenceTemplate", workspaceId, playId] as const,
  sequenceActivity: (workspaceId: string, playId: string, step: string) =>
    [...gtmQueryKeys.all, "sequenceActivity", workspaceId, playId, step] as const,
  leadSequence: (workspaceId: string, leadId: string) =>
    [...gtmQueryKeys.all, "leadSequence", workspaceId, leadId] as const,
};
